//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { BehaviorSubject, catchError, EMPTY, map, Observable, Subject, tap, throwError } from 'rxjs';
import { CompaniesService } from '../system/company/companies-service';
import { ExceptionsService } from './exceptions-service';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })

export class TopBarService {
  
  private _inviewCompanyId        =new BehaviorSubject<number | undefined>(undefined);
  private _sureSimCompanyId       =new BehaviorSubject<number | undefined>(undefined);

  private savedSourceCompany      =new Subject<number | undefined>();
  private savedSourceSim          =new Subject<void              >();
  private savedSourceSupportTicket=new Subject<void              >();
  private savedSourceUser         =new Subject<number | undefined>();
  
  public readonly inviewCompanyId$ : Observable<number | undefined>=this._inviewCompanyId.asObservable();
  public readonly sureSimCompanyId$: Observable<number | undefined>=this._sureSimCompanyId.asObservable();

  public savedCompany$            : Observable<number | undefined>=this.savedSourceCompany.asObservable();
  public savedSim$                : Observable<void              >=this.savedSourceSim.asObservable();
  public savedSourceSupportTicket$: Observable<void              >=this.savedSourceSupportTicket.asObservable();
  public savedUser$               : Observable<number | undefined>=this.savedSourceUser.asObservable();
  public showAddCompanyIcon       : boolean                       =false;
  public showAddSimIcon           : boolean                       =false;
  public showAddSupportTicketIcon : boolean                       =false;
  public showAddUserPortalIcon    : boolean                       =false;
  public showAddUserSimIcon       : boolean                       =false;
  
  constructor(
    private companiesService : CompaniesService,
    private exceptionsService: ExceptionsService
  ) { }

  //#region Icon Visibility

  public hideAdd_Company_SimProv_SupportTicket_UserPortal_UserSim() {
    try {
      this.showAddCompanyIcon      =false;
      this.showAddSimIcon          =false;
      this.showAddSupportTicketIcon=false;
      this.showAddUserPortalIcon   =false;
      this.showAddUserSimIcon      =false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public showAdd_Company_SimProv_SupportTicket() {
    try {
      this.showAddCompanyIcon      =true;
      this.showAddSimIcon          =true;
      this.showAddSupportTicketIcon=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public showAdd_Company_SimProv_SupportTicket_UserPortal_UserSim() {
    try {
      this.showAddCompanyIcon      =true;
      this.showAddSimIcon          =true;
      this.showAddSupportTicketIcon=true;
      this.showAddUserPortalIcon   =true;
      this.showAddUserSimIcon      =true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public showAdd_SimProv_SupportTicket_UserPortal_UserSim() {
    try {
      this.showAddSimIcon          =true;
      this.showAddSupportTicketIcon=true;
      this.showAddUserPortalIcon   =true;
      this.showAddUserSimIcon      =true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Set InviewCompanyID
  
  private setInviewCompanyId(sureSimCompanyId: number) {
    try {
      return this.companiesService.getInviewCompanyId(sureSimCompanyId)
             .pipe(map((res: { result: number | undefined }) => res.result),
                   tap(id => this._inviewCompanyId.next(id)),
                   catchError(e => {
                                this.exceptionsService.handleException(<Error>e);
                                return EMPTY;
                             })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return throwError(() => e);
    }
  }
  
  public setTopBarServiceInviewCompanyId(sureSimCompanyId: number): void {
    try {
      this._sureSimCompanyId.next(sureSimCompanyId);
      
      this.setInviewCompanyId(sureSimCompanyId)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {

        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Data Saved (Company|ICCID|User)

  public companyDataHasBeenSaved(sureSimCompanyId: number | undefined) {
    try {
      this.savedSourceCompany.next(sureSimCompanyId);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public iccidHasBeenProvisioned() {
    try {
      this.savedSourceSim.next();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public supportTicketHasBeenSaved() {
    try {
      this.savedSourceSupportTicket.next();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public userDataHasBeenSaved(sureSimUserId: number | undefined) {
    try {
      this.savedSourceUser.next(sureSimUserId);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion
}
